<template>
  <div class="checkout-products-group">
    <ui-notification
      v-if="group.notification.title"
      :title="group.notification.title"
      :color="group.notification.color"
      class="group-notification"
      :class="{'group-notification_flat': group.flat}"
    >
      <div
        v-if="group.type === 'pickup'"
        class="group-icon-store"
      >
        Магазин
        <f-sprite-icon :icon-link="$options.icons.IconLogo.id" />
      </div>
      <div
        v-else-if="group.type === 'thirdparty'"
        class="group-icon-thirdparty"
      >
        <template v-if="group.thirdPartyType === 'postamat'">
          <f-sprite-icon :icon-link="$options.icons.IconTerminal.id" />
        </template>
        <template v-else>
          <f-sprite-icon :icon-link="$options.icons.IconPickup.id" />
        </template>

        <span>{{ group.name }}</span>
      </div>

      <span class="group-address">
        {{ group.notification.subtitle }}
      </span>

      <template slot="action" v-if="group.actions.length">
        <ui-button
          v-for="a in group.actions"
          :class="[{'disabled': cartIsLoading}]"
          :key="a.text"
          :text="a.text"
          :flat="a.flat"
          @click="a.click()"
        />
      </template>
    </ui-notification>

    <div
      v-show="groupIsOpened"
      class="group-wrapper"
    >
      <checkout-product
        v-for="p in group.products"
        :key="p.lineIds[0]"
        :product="p"
        :shipping-group-id="group.id"
        editable
        @edit="$emit('edit', { product: p, group })"
      />
    </div>

    <div
      class="group-button"
      @click="groupIsOpened = !groupIsOpened"
    >
      {{ button }}
      <chevron-animated :reverse="groupIsOpened" />
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
/* Components */
import ChevronAnimated from "../../assets/icons/chevron-animated";
import CheckoutProduct from "./checkout-product/checkout-product";
/* Icons */
import IconLogo from '@/assets/images/logo.multi.svg';
import IconPickup from '@/assets/icons/pvz.svg';
import IconTerminal from '@/assets/icons/postamat.svg';

export default {
  name: "checkout-products-group",

  icons: {
    IconLogo,
    IconTerminal,
    IconPickup
  },

  components: {
    CheckoutProduct,
    ChevronAnimated
  },

  props: {
    group: {
      type: Object,
      required: true
    },

    cartIsLoading: Boolean
  },

  data() {
    return {
      groupIsOpened: true
    }
  },

  computed: {
    ...mapGetters({
      SHIPPING_GROUPS: 'cart/shippingGroups'
    }),

    button() {
      return this.groupIsOpened ? 'Скрыть товары' : 'Показать товары'
    }
  }
}
</script>

<style lang="scss">
.checkout-products-group {
  margin: 0 (-$containerGapMobile) 32px;

  .group-notification {
    flex-direction: column;
    width: auto;
    padding: 12px 16px 14px 12px;
    margin: 0 $containerGapMobile 0;

    .ui-notification-action {
      width: 100%;
      flex-direction: column;
    }

    .ui-button {
      flex: 1;
      margin: 0;

      &.disabled {
        pointer-events: none;
      }

      &:not(:last-child) {
        margin-bottom: 8px;
      }
    }
  }

  .group-icon-store,
  .group-icon-thirdparty {
    display: flex;
    align-items: center;
    line-height: 24px;
  }

  .group-icon-store {
    color: $black;

    & > svg {
      margin-left: 6px;
      height: 12px;
      width: 83px;
    }
  }

  .group-icon-thirdparty {
    display: flex;
    align-items: flex-start;
    color: $black;

    & > svg {
      float: left;
      width: 20px;
      height: 22px;
      margin-right: 8px;
      color: $gray;
    }
  }

  .group-address {
    display: block;
    margin-top: 4px;
    font-size: 12px;
    line-height: 16px;
  }

  .group-wrapper {
    margin-bottom: 12px;
  }

  .group-button {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 12px;
    font-size: 14px;
    line-height: 24px;
    color: $blue;

    svg {
      width: 12px;
      height: 12px;
      margin-left: 4px;
    }
  }
}

@include breakpoint("tablet") {
  .checkout-products-group {
    margin: 0 0 24px;

    .group-address {
      margin-top: 0;
      font-size: 12px;
      line-height: 20px;
    }

    .group-wrapper {
      margin-bottom: 16px;

      .checkout-product {
        .utils .checkout-product__size {
          min-width: 64px;
          width: 64px;
        }
      }
    }

    .group-button {
      justify-content: flex-start;
      margin-top: 16px;
      margin-left: 20px;
    }

    .group-notification {
      padding: 12px;
      margin: 0;

      .ui-notification-action {
        flex-direction: row;
        margin-top: 12px;
      }

      .ui-button {
        height: 40px;

        &:not(:last-child) {
          margin: 0 8px 0 0;
        }
      }

      &_flat {
        flex-direction: row;

        .ui-notification-content {
          width: 100%;
        }

        .ui-notification-action {
          align-self: flex-start;
          justify-content: flex-end;
          margin-top: 0;
          width: auto;
        }

        .ui-button {
          margin: 0;
          flex: 0 0 auto;

          &:last-child {
            margin-left: 12px;
          }
        }
      }
    }
  }
}

@include breakpoint("desktop") {
  .checkout-products-group {
    margin: 0 0 36px;

    .group-notification {
      margin: 0;
      flex-direction: row;
      align-items: center;

      .ui-notification {
        padding: 20px;
      }

      .ui-button {
        flex: 0 0 auto;

        &:not(:last-child) {
          margin: 0 12px 0 0;
        }
      }

      .ui-notification-action {
        justify-content: flex-end;
        margin: 0 0 0 24px;
      }

      .ui-notification-title,
      .ui-notification-subtitle {
        width: max-content;
        max-width: 640px;
      }

      &_flat {
        .ui-notification-content {
          width: 640px;
        }

        .ui-notification-action {
          margin-left: auto;
        }
      }
    }

    .group-address {
      font-size: 14px;
      line-height: 20px;
    }

    .group-button {
      cursor: pointer;
    }

    .group-wrapper {
      .checkout-product {
        .utils .checkout-product__size {
          min-width: 74px;
          width: 74px;
        }
      }
    }
  }
}
</style>
